import { defineMessages } from 'react-intl';

export default defineMessages({
    menu: {
        id: '_.navigation.menu',
        defaultMessage: 'Menu'
    },
    callUs: {
        id: '_.navigation.call_us',
        defaultMessage: 'Call us'
    },
    chatToUs: {
        id: '_.navigation.chat_to_us',
        defaultMessage: 'Chat online with us'
    },
    emailUs: {
        id: '_.navigation.email_us',
        defaultMessage: 'Email us'
    },
    callPhoneNumber: {
        id: '_.navigation.information.call_number',
        defaultMessage: '+44-020-3778-0105'
    },
    email: {
        id: '_.navigation.information.email',
        defaultMessage: 'support@iwoca.co.uk'
    },
    faq: {
        id: '_.navigation.faq',
        defaultMessage: 'FAQs'
    },
    logout: {
        id: '_.navigation.logout',
        defaultMessage: 'Logout'
    }
});
